/**
 * Login page with "Sign in with Microsoft" button.
 * SDD §7.2 — pages/Login.jsx
 *
 * Redirects to Azure AD OIDC login flow via /api/auth/login.
 */

import { redirectToLogin } from '../lib/auth';
import { useAuth } from '../hooks/useAuth';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorParam = searchParams.get('error');

  useEffect(() => {
    if (!loading && user) {
      navigate('/', { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="relative min-h-dvh flex flex-col items-center justify-center bg-black text-white p-6">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 pointer-events-none"
        style={{ backgroundImage: 'url(/login-background.JPG)' }}
      />
      <div className="absolute inset-0 bg-black/60 pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center">
        <img src="/shifthappens-logo-dark.png" alt="ShiftHappens" className="w-full max-w-[320px] h-auto mb-12" />
        {errorParam === 'expired' && (
          <p className="mb-6 text-sm text-amber-400 text-center max-w-xs">
            Your sign-in session expired. Please try again.
          </p>
        )}
        <button
          onClick={redirectToLogin}
          disabled={loading}
          className="flex items-center gap-3 py-3.5 px-7 text-base font-semibold text-white bg-[#111] border-none rounded-lg cursor-pointer transition-colors duration-150 hover:bg-[#1a1a1a] disabled:opacity-60 disabled:cursor-wait"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#F25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
            <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
            <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
          </svg>
          Sign in with Microsoft
        </button>
      </div>

      <p className="absolute bottom-6 left-0 right-0 z-10 text-xs text-neutral-600 text-center">
        &copy; 2026 Dale City Volunteer Fire Department, Inc. All rights reserved.
      </p>
    </div>
  );
}
